import gql from 'graphql-tag';
import { groupDetailFragment } from './group-detail.fragment';
import { messageFragment } from './message.fragment';
import { lightUserFragment } from './light-user.fragment';

export const messageThreadFragment = gql`
  fragment messageThreadFragment on MessageThread {
    Id
    participantCount

    groupDetail {
      ...groupDetailFragment
    }

    latestMessage {
      ...messageFragment
    }

    participants {
      ...lightUserFragment
    }
  }
  ${groupDetailFragment}
  ${messageFragment}
  ${lightUserFragment}
`;
